export enum EEvidenceEvent {
  // A.1 Akceptacja nadania przesyłki
  SubmissionAcceptance,
  // A.2 Odrzucenie nadania przesyłki
  SubmissionRejection,
  // B.1 Akceptacja przekazania przesyłki pomiędzy usługami RDE
  RelayAcceptance,
  // B.2 Odrzucenie przekazania przesyłki pomiędzy usługami RDE
  RelayRejection,
  // B.3 Błąd przekazania
  RelayFailure,
  // C.1 Notyfikacja o akceptacji odbioru
  NotificationForAcceptance,
  // C.2 Notyfikacja o błędzie akceptacji odbioru
  NotificationForAcceptanceFailure,
  // C.3 Akceptacja preawizacji
  ConsignmentAcceptance,
  // C.4 Odrzucenie preawizacji
  ConsignmentRejection,
  // C.5 Wygaśnięcie czasu na akceptację/odrzucenie przesyłki
  AcceptanceRejectionExpiry,
  // D.1 Przesyłka przygotowana do odbioru
  ContentConsignment,
  // D.2 Błąd przygotowania przesyłki do odbioru z powodu błędu technicznego
  ContentConsignmentFailure,
  // D.3 Notyfikacja o przesyłce gotowej do odbioru
  ConsignmentNotification,
  // D.4 Błąd notyfikacji o przesyłce gotowej do odbioru
  ConsignmentNotificationFailure,
  // E.1 Dostarczenie przesyłki
  ContentHandover,
  // E.2 Błąd dostarczenia przesyłki
  ContentHandoverFailure,
  // F.1 Przekazanie do usługi niebędącej usługą RDE
  RelayToNonERDS,
  // F.2 Błąd przekazania do usługi niebędącej usługą RDE
  RelayToNonERDSFailure,
  // F.3 Odbiór przesyłki przez usługę niebędącą usługą RDE
  ReceivedFromNonERDS,
}
